import { axiosBasic } from "../../../api/axios";
import { config } from "../../../api/endPoints";

const {
  AppraisalAdmin,
  UserAppraisal,
  AppraisalGoals,
  AppraisalRetrospective,
  AppraisalEvidence,
  AppraisalPdp,
  AppraisalOneToOne,
  AppraisalLms,
} = config.REST_API;

const unwrap = (res) => {
  const body = res?.data;
  if (body && typeof body === "object" && "success" in body && body.success === false) {
    throw new Error(body.message || "Request failed");
  }
  return body?.data ?? body;
};

export const getAppraisalSettings = () => axiosBasic.get(AppraisalAdmin.Settings).then(unwrap);
export const saveAppraisalSettings = (payload) => axiosBasic.post(AppraisalAdmin.Settings, payload).then(unwrap);
export const getAppraisalSchedule = () => axiosBasic.get(AppraisalAdmin.Schedule).then(unwrap);
export const saveAppraisalSchedule = (payload) => axiosBasic.post(AppraisalAdmin.Schedule, payload).then(unwrap);
export const getAppraisalPeriods = () => axiosBasic.get(AppraisalAdmin.Periods).then(unwrap);
export const saveAppraisalPeriod = (payload) => axiosBasic.post(AppraisalAdmin.Periods, payload).then(unwrap);
export const getAppraisalValues = () => axiosBasic.get(AppraisalAdmin.Values).then(unwrap);
export const saveAppraisalValue = (payload) => axiosBasic.post(AppraisalAdmin.Values, payload).then(unwrap);
export const deactivateAppraisalValue = (id) =>
  axiosBasic.post(AppraisalAdmin.DeactivateValue(id)).then(unwrap);
export const getAppraisalBehaviorGroups = () => axiosBasic.get(AppraisalAdmin.BehaviorGroups).then(unwrap);
export const saveAppraisalBehaviorGroup = (payload) => axiosBasic.post(AppraisalAdmin.BehaviorGroups, payload).then(unwrap);
export const deactivateAppraisalBehaviorGroup = (id) =>
  axiosBasic.post(AppraisalAdmin.DeactivateBehaviorGroup(id)).then(unwrap);
export const getAppraisalBehaviours = (behaviorGroupId) =>
  axiosBasic.get(AppraisalAdmin.Behaviours, { params: behaviorGroupId ? { behaviorGroupId } : undefined }).then(unwrap);
export const getAppraisalBehaviors = getAppraisalBehaviours;
export const saveAppraisalBehaviour = (payload) => axiosBasic.post(AppraisalAdmin.Behaviours, payload).then(unwrap);
export const saveAppraisalBehavior = saveAppraisalBehaviour;
export const deactivateAppraisalBehaviour = (id) =>
  axiosBasic.post(AppraisalAdmin.DeactivateBehaviour(id)).then(unwrap);
export const deactivateAppraisalBehavior = deactivateAppraisalBehaviour;
export const getAppraisalRatingScale = () => axiosBasic.get(AppraisalAdmin.RatingScale).then(unwrap);
export const saveAppraisalRatingScale = (payload) => axiosBasic.post(AppraisalAdmin.RatingScale, payload).then(unwrap);
export const getAppraisalCompliance = () => axiosBasic.get(AppraisalAdmin.Compliance).then(unwrap);
export const getAppraisalAdminDashboard = () => axiosBasic.get(AppraisalAdmin.Dashboard).then(unwrap);
export const getAppraisalOffices = () => axiosBasic.get(AppraisalAdmin.Offices).then(unwrap);
export const startAppraisalCycle = (payload) => axiosBasic.post(AppraisalAdmin.StartCycle, payload || { isAllOffices: true }).then(unwrap);
export const stopAppraisalCycle = () => axiosBasic.post(AppraisalAdmin.StopCycle).then(unwrap);

export const getMyCurrentAppraisal = () => axiosBasic.get(UserAppraisal.MineCurrent).then(unwrap);
export const getMyAppraisalHistory = () => axiosBasic.get(UserAppraisal.MineHistory).then(unwrap);
export const getAppraisalFeatureFlags = () => axiosBasic.get(UserAppraisal.Features).then(unwrap);
export const getTeamAppraisals = (companyAppraisalId) =>
  axiosBasic.get(UserAppraisal.Team, { params: companyAppraisalId ? { companyAppraisalId } : undefined }).then(unwrap);
export const getTeamAppraisalCycles = () => axiosBasic.get(UserAppraisal.TeamCycles).then(unwrap);
export const getAppraisalTeamDashboard = () => axiosBasic.get(UserAppraisal.TeamDashboard).then(unwrap);
export const getAppraisalDetail = (id) => axiosBasic.get(`${UserAppraisal.DetailBase}${encodeURIComponent(id)}`).then(unwrap);
export const saveAppraisalReview = (payload) => axiosBasic.post(UserAppraisal.Reviews, payload).then(unwrap);
export const submitSelfAppraisal = (payload) => axiosBasic.post(UserAppraisal.SubmitSelf, payload).then(unwrap);
export const submitManagerAppraisal = (payload) => axiosBasic.post(UserAppraisal.SubmitManager, payload).then(unwrap);
export const submitMeetingAppraisal = (payload) => axiosBasic.post(UserAppraisal.SubmitMeeting, payload).then(unwrap);
export const recommendAppraisalPayIncrease = (payload) =>
  axiosBasic.post(UserAppraisal.RecommendPayIncrease, payload).then(unwrap);
export const saveAppraisalRetroReview = (payload) => axiosBasic.post(UserAppraisal.RetroReviews, payload).then(unwrap);

export const getAppraisalObjectives = () => axiosBasic.get(AppraisalGoals.Objectives).then(unwrap);
export const saveAppraisalObjective = (payload) => axiosBasic.post(AppraisalGoals.Objectives, payload).then(unwrap);
export const getAppraisalObjectiveGroups = () => axiosBasic.get(AppraisalGoals.ObjectiveGroups).then(unwrap);
export const saveAppraisalObjectiveGroup = (payload) => axiosBasic.post(AppraisalGoals.ObjectiveGroups, payload).then(unwrap);
export const getMyGoals = () => axiosBasic.get(AppraisalGoals.Mine).then(unwrap);
export const getTeamGoals = () => axiosBasic.get(AppraisalGoals.Team).then(unwrap);
export const getAppraisalGoal = (id) => axiosBasic.get(`${AppraisalGoals.DetailBase}${encodeURIComponent(id)}`).then(unwrap);
export const saveAppraisalGoal = (payload) => axiosBasic.post(AppraisalGoals.Save, payload).then(unwrap);
export const submitGoalForApproval = (payload) => axiosBasic.post(AppraisalGoals.SubmitApproval, payload).then(unwrap);
export const approveGoal = (payload) => axiosBasic.post(AppraisalGoals.Approve, payload).then(unwrap);
export const rateGoalAsUser = (payload) => axiosBasic.post(AppraisalGoals.RateUser, payload).then(unwrap);
export const agreeGoalAsManager = (payload) => axiosBasic.post(AppraisalGoals.AgreeManager, payload).then(unwrap);
export const discussGoalAsManager = (payload) => axiosBasic.post(AppraisalGoals.DiscussManager, payload).then(unwrap);
export const completeGoal = (payload) => axiosBasic.post(AppraisalGoals.Complete, payload).then(unwrap);
export const addGoalComment = (payload) => axiosBasic.post(AppraisalGoals.Comments, payload).then(unwrap);

export const getAppraisalsRetrospectives = () => axiosBasic.get(AppraisalRetrospective.List).then(unwrap);
export const saveAppraisalRetrospective = (payload) => axiosBasic.post(AppraisalRetrospective.List, payload).then(unwrap);
export const deactivateAppraisalRetrospective = (id) =>
  axiosBasic.post(AppraisalRetrospective.Deactivate(id)).then(unwrap);
export const getAppraisalRetrospectiveGroups = () => axiosBasic.get(AppraisalRetrospective.Groups).then(unwrap);
export const saveAppraisalRetrospectiveGroup = (payload) =>
  axiosBasic.post(AppraisalRetrospective.Groups, payload).then(unwrap);
export const deactivateAppraisalRetrospectiveGroup = (id) =>
  axiosBasic.post(AppraisalRetrospective.DeactivateGroup(id)).then(unwrap);

export const getMyEvidence = () => axiosBasic.get(AppraisalEvidence.Mine).then(unwrap);
export const saveEvidence = (payload) => axiosBasic.post(AppraisalEvidence.List, payload).then(unwrap);
export const deleteEvidence = (id) => axiosBasic.delete(`${AppraisalEvidence.DetailBase}${encodeURIComponent(id)}`).then(unwrap);

export const getMyPdpTasks = () => axiosBasic.get(AppraisalPdp.Mine).then(unwrap);
export const getTeamPdpTasks = () => axiosBasic.get(AppraisalPdp.Team).then(unwrap);
export const getPdpTask = (id) => axiosBasic.get(`${AppraisalPdp.DetailBase}${encodeURIComponent(id)}`).then(unwrap);
export const savePdpTask = (payload) => axiosBasic.post(AppraisalPdp.Save, payload).then(unwrap);
export const submitPdpForApproval = (payload) => axiosBasic.post(AppraisalPdp.SubmitApproval, payload).then(unwrap);
export const approvePdp = (payload) => axiosBasic.post(AppraisalPdp.Approve, payload).then(unwrap);
export const completePdp = (payload) => axiosBasic.post(AppraisalPdp.Complete, payload).then(unwrap);
export const addPdpComment = (payload) => axiosBasic.post(AppraisalPdp.Comments, payload).then(unwrap);

export const getMyOneToOnes = () => axiosBasic.get(AppraisalOneToOne.Mine).then(unwrap);
export const getTeamOneToOnes = () => axiosBasic.get(AppraisalOneToOne.Team).then(unwrap);
export const getOneToOne = (id) =>
  axiosBasic.get(`${AppraisalOneToOne.DetailBase}${encodeURIComponent(id)}`).then(unwrap);
export const saveOneToOne = (payload) => axiosBasic.post(AppraisalOneToOne.Save, payload).then(unwrap);
export const completeOneToOne = (payload) => axiosBasic.post(AppraisalOneToOne.Complete, payload).then(unwrap);
export const addOneToOneComment = (payload) => axiosBasic.post(AppraisalOneToOne.Comments, payload).then(unwrap);

export const getMyOneToOneConversations = () => axiosBasic.get(AppraisalOneToOne.ConversationsMine).then(unwrap);
export const getTeamOneToOneConversations = () => axiosBasic.get(AppraisalOneToOne.ConversationsTeam).then(unwrap);
export const getOneToOneConversation = (id) =>
  axiosBasic.get(`${AppraisalOneToOne.ConversationsDetailBase}${encodeURIComponent(id)}`).then(unwrap);
export const saveOneToOneConversation = (payload) =>
  axiosBasic.post(AppraisalOneToOne.ConversationsSave, payload).then(unwrap);
export const completeOneToOneConversation = (payload) =>
  axiosBasic.post(AppraisalOneToOne.ConversationsComplete, payload).then(unwrap);
export const addOneToOneConversationComment = (payload) =>
  axiosBasic.post(AppraisalOneToOne.ConversationsComments, payload).then(unwrap);

export const getActiveLmsLinks = () => axiosBasic.get(AppraisalLms.Active).then(unwrap);
export const getAllLmsLinks = () => axiosBasic.get(AppraisalLms.List).then(unwrap);
export const saveLmsLink = (payload) => axiosBasic.post(AppraisalLms.List, payload).then(unwrap);
export const deleteLmsLink = (id) => axiosBasic.delete(`${AppraisalLms.DetailBase}${encodeURIComponent(id)}`).then(unwrap);

export const APPRAISAL_STATUS = {
  Pending: 0,
  SelfSubmitted: 1,
  ManagerSubmitted: 2,
  MeetingConfirmed: 3,
};

export const GOAL_STATUS = {
  Draft: 0,
  ReadyForApproval: 1,
  Approved: 2,
  RatedByUser: 3,
  ManagerAgreed: 4,
  ManagerDiscussed: 5,
  Completed: 6,
};

export const PDP_STATUS = {
  Draft: 0,
  ReadyForApproval: 1,
  Approved: 2,
  Completed: 3,
};

export const appraisalStatusLabel = (status) => {
  switch (Number(status)) {
    case 0:
      return "Pending self assessment";
    case 1:
      return "Awaiting manager";
    case 2:
      return "Ready for meeting";
    case 3:
      return "Meeting confirmed";
    default:
      return "Unknown";
  }
};

export const goalStatusLabel = (status) => {
  switch (Number(status)) {
    case 0:
      return "Draft";
    case 1:
      return "Ready for approval";
    case 2:
      return "Approved";
    case 3:
      return "Rated by user";
    case 4:
      return "Manager agreed";
    case 5:
      return "Needs discussion";
    case 6:
      return "Completed";
    default:
      return "Unknown";
  }
};

export const pdpStatusLabel = (status) => {
  switch (Number(status)) {
    case 0:
      return "Draft";
    case 1:
      return "Awaiting approval";
    case 2:
      return "Approved";
    case 3:
      return "Completed";
    default:
      return "Unknown";
  }
};
